"use strict";
var coverage_cart_coverage_view_model_1 = require("./coverage-cart-coverage-view.model");
var coverage_cart_package_view_model_1 = require("./coverage-cart-package-view.model");
var CoverageCartViewModel = (function () {
    function CoverageCartViewModel() {
        this.package = new coverage_cart_package_view_model_1.CoverageCartPackageViewModel();
        this.optionalCoverages = new Array();
    }
    CoverageCartViewModel.ConvertApiPolicyGetForEditResponseIntoCoverageCart = function (policyResponse) {
        var convertedModel = new CoverageCartViewModel();
        convertedModel.originalCost = policyResponse.policy.premium;
        convertedModel.totalCost = policyResponse.policy.premium;
        if (convertedModel.originalCost) {
            convertedModel.difference = convertedModel.totalCost - convertedModel.originalCost;
        }
        convertedModel.package = coverage_cart_package_view_model_1.CoverageCartPackageViewModel.ConvertApiPolicyGetForEditResponseIntoCoverageCartPackage(policyResponse);
        return convertedModel;
    };
    CoverageCartViewModel.ConvertApiQuoteResponseIntoCoverageCart = function (quoteResponse, optionalCoverages, originalCost) {
        if (optionalCoverages === void 0) { optionalCoverages = null; }
        if (originalCost === void 0) { originalCost = null; }
        var convertedModel = new CoverageCartViewModel();
        convertedModel.package = coverage_cart_package_view_model_1.CoverageCartPackageViewModel.ConvertApiQuoteResponseIntoCoverageCartPackage(quoteResponse);
        // Calculate Selected Coverages Cost
        var optionalCoverageTotal = 0;
        if (optionalCoverages && optionalCoverages.length > 0) {
            for (var i = 0; i <= optionalCoverages.length - 1; i++) {
                if (optionalCoverages[i].isSelected) {
                    var premium = 0;
                    // Check to see if we need to set the premium from the coverage or the limitsByPremium
                    if (Object.getOwnPropertyNames(optionalCoverages[i].premiumsByLimit).length === 0) {
                        premium = optionalCoverages[i].premium;
                    }
                    else if (Object.getOwnPropertyNames(optionalCoverages[i].premiumsByLimit).length > 0) {
                        premium = optionalCoverages[i].premium = optionalCoverages[i].premiumsByLimit[optionalCoverages[i].coverageLimit];
                    }
                    optionalCoverageTotal += premium;
                    // MA has fees for optional coverages. If this was a quote with no optional coverages passed in,
                    // then aggregated fees are 0, but each optional coverage will have its fees filled in
                    if ((!quoteResponse.coverageFees || quoteResponse.coverageFees === 0) && optionalCoverages[i].fees) {
                        convertedModel.package.fees += optionalCoverages[i].fees;
                    }
                }
            }
            // Now add the selected optional to the cart component
            convertedModel.optionalCoverages = coverage_cart_coverage_view_model_1.CoverageCartCoverageViewModel.ConvertEditCoveragesIntoCoverageCartCoverages(optionalCoverages);
        }
        // Calculate Total Cost
        convertedModel.totalCost = convertedModel.package.basePremium + convertedModel.package.fees + optionalCoverageTotal;
        // Set Original Cost and Difference
        if (originalCost != null) {
            convertedModel.originalCost = originalCost;
            convertedModel.difference = convertedModel.totalCost - convertedModel.originalCost;
        }
        return convertedModel;
    };
    return CoverageCartViewModel;
}());
exports.CoverageCartViewModel = CoverageCartViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/coverage-cart/coverage-cart-view.model.js